import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ServicesModule, API_CONFIG } from './services.module';
import { Observable } from 'rxjs/internal/Observable';
import * as queryString from 'querystring';
import { ResultModel, NeedGoogleAuthModel, NeedSecurityCodeModel, AuthSecurityCodeModel } from '../model/system.model';
import { map } from 'rxjs/internal/operators';

@Injectable({ providedIn: ServicesModule })
export class SysConfigService {

    constructor(
        private http: HttpClient,
        @Inject(API_CONFIG) private uri: string
    ) {

    }

    /**
     * 是否
     * @param formValue 
     */
    needGoogleAuth(formValue): Observable<ResultModel<NeedGoogleAuthModel>> {
        const params = new HttpParams({ fromString: queryString.stringify(formValue) });
        return this.http.get(this.uri + 'need-google-auth', { params }).pipe(
            map((res: ResultModel<NeedGoogleAuthModel>) => {
                return res;
            })
        )
    }

    /**
     * 是否需要验证码/滑块验证码
     */
    needSecurityCode(formValue): Observable<ResultModel<NeedSecurityCodeModel>> {
        const params = new HttpParams({ fromString: queryString.stringify(formValue) });
        return this.http.get(this.uri + 'need-security-code', { params }).pipe(
            map((res: ResultModel<NeedSecurityCodeModel>) => {
                return res;
            })
        )
    }

    /**
     * 获取线路
     */
    getDomainUrls(): Observable<ResultModel<any>> {
        return this.http.post(this.uri + 'utils/domain-urls', {}).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /**
     * 获取客服地址
     */
    getServiceUrl(): Observable<ResultModel<any>> {
        return this.http.post(this.uri + 'utils/service-url', {}).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }

    /**
     * 获取挂机软件地址
     * @ param formValue
     */
    getHangupAddress() {
        const url = 'utils/gua-ji-url';
        return this.http.post(this.uri + url, null).pipe(map((res: ResultModel<any>) => {
            return res;
        }));
    }

    /**
     * 验证滑块验证码
     */
    authSecurityCode(formValue): Observable<ResultModel<AuthSecurityCodeModel>> {
        const params = new HttpParams({ fromString: queryString.stringify(formValue) });
        return this.http.get(this.uri + 'auth-security-code', { params }).pipe(
            map((res: ResultModel<AuthSecurityCodeModel>) => {
                return res;
            })
        )
    }

    /**
     * 获取客服地址
     */
    pcPictures(): Observable<ResultModel<any>> {
        return this.http.post(this.uri + 'utils/pc-pictures', {}).pipe(
            map((res: ResultModel<any>) => {
                return res;
            })
        )
    }
    /**
     * 中奖金额
     */
    getBouns(): Observable<ResultModel<NeedSecurityCodeModel>> {
        return this.http.get(this.uri + 'game-lottery/gety-bouns-by-time').pipe(
            map((res: ResultModel<NeedSecurityCodeModel>) => {
                return res;
            })
        );
    }
    // /api/activity/get-config?code=VM7TNgFW
    /**
     * 获取活动
     */
    getAcrivityList(formValue) {
        const params = new HttpParams({ fromString: queryString.stringify(formValue) });
        return this.http.post(this.uri + 'activity/get-config', params).pipe(map((res: ResultModel<any>) => {
            return res;
        }))
    }

    /**
    * 领取活动奖励
    *  mango 2019-6-8
    */
   getReward(formValue) {
    const  params = new HttpParams({ fromString: queryString.stringify(formValue) });
    return this.http.post(this.uri + 'activity/get-reward', params).pipe(map((res: ResultModel<any>) => {
        return res;
    }));
}

    /**
     * 公告推送
     */
    noticePull(formValue) {
        const params = new HttpParams({ fromString: queryString.stringify(formValue) });
        return this.http.post(this.uri + 'game-lottery/pull-notice', params).pipe(map((res: ResultModel<any>) => {
            return res;
        }))
    }
    /**
   * 阻止多条公告推送
   */
     stopNoticePull() {
        return this.http.post(this.uri + 'game-lottery/delete-account-notice', null).pipe(map((res: ResultModel<any>) => {
            return res;
        }))
    }
}